export const startRouteByRole = {
    finance: "/credit-logs",
    cUser: "/reports/shift-score",
    sOperation: "/map",
    hrEmployment: "/couriers",
    default: "/map"
};

export const getStartRoute = ({role, isPoolCustomer = false, isUatCustomer}) => {
    if (isUatCustomer && isPoolCustomer) {
        return "/musteri";
    }

    if (isPoolCustomer) {
        return "/create-delivery-request";
    }

    return startRouteByRole[role] || startRouteByRole.default;
};
